import React from 'react';
import { Hero } from '../components/Hero';
import { Diagnosis } from '../components/Diagnosis';
import { TheCure } from '../components/TheCure';
import { CTASection } from '../components/CTASection';
export function LandingPage() {
  return <main className="min-h-screen bg-carbon font-inter" data-id="element-51">
      {/* Simple Header */}
      <header className="border-b border-gray-900 bg-carbon/95 backdrop-blur-sm sticky top-0 z-50" data-id="element-52">
        <div className="max-w-6xl mx-auto px-4 h-20 flex items-center justify-between" data-id="element-53">
          <div className="font-extrabold text-2xl tracking-tighter text-white" data-id="element-54">
            Doctor<span className="text-gold" data-id="element-55">Ecommerce</span>
          </div>
          <a href="https://calendar.app.google/PYPdcRoYne7QrNJA7" target="_blank" rel="noopener noreferrer" className="text-sm font-semibold text-gold hover:text-white transition-colors" data-id="element-56">
            Agendar Llamada
          </a>
        </div>
      </header>

      <Hero data-id="element-57" />
      <Diagnosis data-id="element-58" />
      <TheCure data-id="element-59" />
      <CTASection data-id="element-60" />

      {/* Simple Footer */}
      <footer className="border-t border-gray-900 py-8 text-center text-gray-600 text-sm" data-id="element-61">
        <p data-id="element-62">
          © {new Date().getFullYear()} Doctor Ecommerce. Todos los derechos
          reservados.
        </p>
      </footer>
    </main>;
}